import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "./index.css";
import AllRoutes from "./views/allRoutes";
import QueryClientWrapper from "./utils/queryClientWrapper";
import ErrorBoundary from "./components/ErrorBoundary";
import { AuthUserProvider } from "./context/authUser.context";
import { InstituteProvider } from "./context/institute.context";
import { HelpProvider } from "./context/help.context";
import { InstituteAssignmentHandler } from "./components/InstituteAssignmentHandler";
import { muiThemeOverrideHandler } from "./design-system/theme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientWrapper>
        <AuthUserProvider>
          <InstituteProvider>
            <InstituteAssignmentHandler>
              <HelpProvider>
                <ThemeProvider theme={muiThemeOverrideHandler}>
                  <CssBaseline />
                  <AllRoutes />
                </ThemeProvider>
              </HelpProvider>
            </InstituteAssignmentHandler>
          </InstituteProvider>
        </AuthUserProvider>
      </QueryClientWrapper>
    </ErrorBoundary>
  </React.StrictMode>,
);
